import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _obj;
/* import __COLOCATED_TEMPLATE__ from './edit-category-tags.hbs'; */
import { action, set } from "@ember/object";
import { and, empty } from "@ember/object/computed";
import { buildCategoryPanel } from "discourse/components/edit-category-panel";
import TEMPLATE from "./edit-category-tags.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, buildCategoryPanel("tags", (_obj = {
  allowedTagsEmpty: empty("category.allowed_tags"),
  allowedTagGroupsEmpty: empty("category.allowed_tag_groups"),
  disableAllowGlobalTags: and("allowedTagsEmpty", "allowedTagGroupsEmpty"),
  onTagGroupChange(rtg, valueArray) {
    // A little strange, but we're using a multi-select component
    // to select a single tag group. This action takes the array
    // and extracts the first value in it.
    set(rtg, "name", valueArray[0]);
  },
  addRequiredTagGroup() {
    this.category.required_tag_groups.pushObject({
      min_count: 1
    });
  },
  deleteRequiredTagGroup(rtg) {
    this.category.required_tag_groups.removeObject(rtg);
  }
}, (_applyDecoratedDescriptor(_obj, "onTagGroupChange", [action], Object.getOwnPropertyDescriptor(_obj, "onTagGroupChange"), _obj), _applyDecoratedDescriptor(_obj, "addRequiredTagGroup", [action], Object.getOwnPropertyDescriptor(_obj, "addRequiredTagGroup"), _obj), _applyDecoratedDescriptor(_obj, "deleteRequiredTagGroup", [action], Object.getOwnPropertyDescriptor(_obj, "deleteRequiredTagGroup"), _obj)), _obj)));